import {Component, Inject, OnInit} from '@angular/core';
import {HttpService} from '../../../../../../../core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-buyer-choice-delete',
  templateUrl: './buyer-choice-delete.component.html',
  styleUrls: ['./buyer-choice-delete.component.scss']
})

export class BuyerChoiceDeleteComponent implements OnInit{
  constructor(
    private httpService: HttpService,
    private dialogRef: MatDialogRef<any>,
    private toastrService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
  }

  cancel() {

  }

  deleteBuyerChoice() {
    this.httpService.deleteBuyerChoiceByDevAdmin(this.data.buyerChoice.id).subscribe((res: any) => {
      console.log(res);
      if (res.code === 1) {
        this.dialogRef.close({code: 1});
        this.toastrService.success('Buyer choice has been deleted');
      } else {
        this.dialogRef.close({code: 0});
        this.toastrService.error('Failed to delete buyer choice');

      }
    })
  }
}
